import createReducer from 'common/redux/utils/createReducer';
import { List, Map } from 'immutable';
import {
  REQUEST_MESSAGES,
  RECEIVE_MESSAGES,
  CHANGE_SCROLL_POSITION,
  REQUEST_READ_MESSAGES,
  MESSAGES_READ,
  MESSAGES_READ_ERROR,
} from 'messaging/actions/mailbox';
import {
  REQUEST_SEND_MESSAGE,
  MESSAGE_SENT,
  MESSAGE_SEND_ERROR,
} from 'messaging/actions/message';
import { SSE_MESSAGE } from 'services/sse';
import { LOCATION_CHANGE } from 'react-router-redux';
import { MessageTypes } from 'messaging/constants';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  isSending: false,
  isReading: false,
  messages: List(),
  scrollPositions: Map(),
};

const mailbox = createReducer(initialState, {
  [REQUEST_MESSAGES](state, { user }) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [RECEIVE_MESSAGES](state, { messages, total }) {
    return {
      ...state,
      isFetching: false,
      total,
      messages: state.messages.concat(messages).sortBy(m => m.index),
    };
  },
  [CHANGE_SCROLL_POSITION](state, { user, position }) {
    return {
      ...state,
      scrollPositions: state.scrollPositions.set(user.toString(), position),
    };
  },
  [LOCATION_CHANGE](state, { query }) {
    if (query.user && query.user !== state.selectedUser) {
      return {
        ...state,
        selectedUser: query.user,
        messages: List(),
        total: undefined,
      };
    }

    return state;
  },
  [SSE_MESSAGE](state, { event }) {
    if (event._type && event._type === MessageTypes.MESSAGE_CREATED) {
      const userMessages = event.content.filter(
        m => m.user_id.toString() === state.selectedUser
      );

      return {
        ...state,
        total: state.total + userMessages.length,
        messages: state.messages.concat(userMessages),
      };
    }

    return state;
  },
  [REQUEST_SEND_MESSAGE](state) {
    return {
      ...state,
      isSending: true,
    };
  },
  [MESSAGE_SENT](state) {
    return {
      ...state,
      isSending: false,
    };
  },
  [MESSAGE_SEND_ERROR](state, { error }) {
    return {
      ...state,
      isSending: false,
      sendError: error,
    };
  },
  [REQUEST_READ_MESSAGES](state) {
    return {
      ...state,
      isReading: true,
    };
  },
  [MESSAGES_READ](state) {
    return {
      ...state,
      isReading: false,
    };
  },
  [MESSAGES_READ_ERROR](state, { error }) {
    return {
      ...state,
      isReading: false,
      readError: error,
    };
  },
});

export default mailbox;



// WEBPACK FOOTER //
// ./src/modules/messaging/reducers/mailbox.js